import React from 'react';
import logo from '../../../assets/logo/LOGO_CAPBAY_VERTICAL_CROPPED.png';
import { useDict } from '../../../contexts/LanguageContext';
import LogOutForm from './LogoutForm';

const Logout = () => {
    const dict = useDict();
    
    return (
        <div className="account account--photo">
            <div className="account__wrapper">
                <div className="account__card">
                    <span
                        className="account__logo"
                        style={{
                            color: '#202b5e',
                            fontFamily: 'Georgia',
                            fontSize: '30px',
                            fontWeight: 500,
                        }}
                    >
                        <img
                            src={logo}
                            alt="logo"
                            style={{
                                width: '55%',
                                marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                                marginBottom: '5%',
                            }}
                        />
                    </span>
                    <h4
                        style={{
                            textAlign: 'center',
                            marginBottom: '30px',
                        }}
                    >
                        {dict.logout}
                    </h4>
                    <LogOutForm />
                    <div className="account__or_divide">
                        <div style={{ fontSize: '11px', paddingTop: '20px' }}>
                            {dict.regulatedByText}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Logout;
